// 파트너(업체) 중앙 레지스트리.
// 파트너 nav · 월말정산 nav · 라우트 · 오늘의 주문서(DailyOrders) 가 모두 이 배열에서 파생된다.
// 파트너를 추가하려면 이 배열에 항목 하나만 추가하면 위 네 곳에 자동으로 반영된다.

export interface SmsTemplateDef {
  label: string;                  // 화면에 표시될 이름 (예: "유기농 당근")
  body: string;                   // 메시지 본문
  productNameIncludes?: string[]; // 상품명에 이 키워드들 중 하나라도 포함되면 매칭 (없으면 기본 fallback)
}

export interface VendorTemplate {
  columns: { header: string; key: string; defaultValue?: string }[];
  senderName: string;
  senderPhone: string;
  senderAddress: string;
}

export interface VendorDef {
  key: string;                 // 라우트 슬러그 & 오늘의 주문서 key. 주문서 경로는 `/admin/${key}`
  name: string;
  code: string;                // 상품코드 prefix (예: 'JS' → 'JS-...' 상품 자동 추출)
  courier?: string;
  consolidate?: boolean;
  filenameDateOffset?: number;
  excludeRules?: { triggerKeywords: string[]; excludeKeywords: string[] }[];
  smsTemplate?: string;        // 단일 템플릿 (하위호환)
  smsTemplates?: SmsTemplateDef[]; // 여러 템플릿 (상품별 매칭 지원)
  ledgerVendorName?: string;
  template?: VendorTemplate;   // 주문서(VendorPage) 설정. custom 파트너는 없음
  custom?: 'blueberry';        // VendorPage 대신 전용 컴포넌트를 쓰는 파트너
  settlement?: boolean;        // 월말정산 페이지 노출 여부
}

export const VENDORS: VendorDef[] = [
  { key: 'blueberry', name: '머드네농장', code: 'MD', custom: 'blueberry', settlement: true },
  {
    key: 'jeomsuni',
    name: '점순이네',
    code: 'JS',
    courier: '롯데택배',
    filenameDateOffset: 1,
    settlement: true,
    template: {
      columns: [
        { header: '받는사람', key: 'recipientName' },
        { header: '받는사람 연락처', key: 'recipientPhone' },
        { header: '연락처2', key: 'recipientPhone2' },
        { header: '받는사람 주소', key: 'address' },
        { header: '품명', key: 'productName' },
        { header: '수량', key: 'quantity' },
        { header: '보내는사람', key: 'senderName' },
        { header: '보내는사람 연락처', key: 'senderPhone' },
        { header: '보내는사람 주소', key: 'senderAddress' },
        { header: '배송메세지', key: 'memo' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-4633-4634',
      senderAddress: '(63500) 제주특별자치도 서귀포시 대정읍 도원로17번길 12 1층 창고',
    },
  },
  {
    key: 'serin',
    name: '세린농장',
    code: 'SR',
    courier: '한진택배',
    consolidate: true,
    filenameDateOffset: 1,
    settlement: true,
    template: {
      columns: [
        { header: '받으시는분', key: 'recipientName' },
        { header: '받는분 전화', key: 'recipientPhone' },
        { header: '받는분담당자', key: '_empty1' },
        { header: '받는분 핸드폰', key: 'recipientPhone2' },
        { header: '받는분우편번호', key: '_empty2' },
        { header: '받는분주소', key: 'address' },
        { header: '보내시는분', key: 'senderName' },
        { header: '보내시는분전화', key: 'senderPhone' },
        { header: '보내시는분담당자', key: '_empty3' },
        { header: '담당자전화', key: '_empty4' },
        { header: '보내는분우편번호', key: '_empty5' },
        { header: '보내는분주소', key: 'senderAddress' },
        { header: '수량', key: 'quantity' },
        { header: '품목', key: 'productName' },
        { header: '운임타입', key: '_empty6' },
        { header: '지불조건', key: '_empty7' },
        { header: '출고번호', key: '_empty8' },
        { header: '특기사항', key: 'memo' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-4633-4634',
      senderAddress: '제주시 애월읍',
    },
  },
  {
    key: 'yugi',
    name: '유기촌',
    code: 'YKC',
    courier: '한진택배',
    consolidate: true,
    filenameDateOffset: 1,
    settlement: true,
    smsTemplate: `안녕하세요^^
제주로부터입니다.

오늘 제주에서 유기농 흙 당근이 출발하여 안내드려요.

당근은 받으신 후 박스를 열어 수분을 한번 날려주시고,
신문지나 키친타월로 하나씩 감싸서 냉장보관 해 주시면 좋아요.

■ 리뷰 이벤트 ■
스토어/인스타그램에 리뷰를 남겨주시면 추첨후 10,000원 포인트를 드리고 있어요!
고객님의 맛있는 이야기를 들려주세요.

스토어 : http://fromjeju.store
인스타그램 : https://instagram.com/from.jeju__/

#제주로부터`,
    template: {
      columns: [
        { header: '받으시는 분', key: 'recipientName' },
        { header: '받으시는분전화', key: 'recipientPhone' },
        { header: '받는분핸드폰', key: 'recipientPhone2' },
        { header: '받는분총주소', key: 'address' },
        { header: '수량', key: 'quantity' },
        { header: '보내시는 분', key: 'senderName' },
        { header: '보내는분전화', key: 'senderPhone' },
        { header: '보내는분담당자HP', key: '_empty1' },
        { header: '보내는분총주소', key: 'senderAddress' },
        { header: '품목명', key: 'productName' },
        { header: '', key: '_empty2' },
        { header: '운임Type', key: '_empty3' },
        { header: '지불조건', key: '_empty4' },
        { header: '배송메시지', key: 'memo' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-4633-4634',
      senderAddress: '제주도 성산읍 삼달리 삼달로 229번길 7',
    },
  },
  {
    key: 'sonong',
    name: '소농로드',
    code: 'SN',
    courier: 'CJ대한통운',
    consolidate: true,
    filenameDateOffset: 1,
    settlement: true,
    excludeRules: [{ triggerKeywords: ['흑돼지스테이크'], excludeKeywords: ['흑돼지스테이크', '채소 커리'] }],
    template: {
      columns: [
        { header: '받는분성명', key: 'recipientName' },
        { header: '받는분전화번호', key: 'recipientPhone' },
        { header: '받는분기타연락처', key: 'recipientPhone2' },
        { header: '받는분주소(전체, 분할)', key: 'address' },
        { header: '보내는분성명', key: 'senderName' },
        { header: '보내는분전화번호', key: 'senderPhone' },
        { header: '보내는분주소(전체, 분할)', key: 'senderAddress' },
        { header: '품목명', key: 'productName' },
        { header: '박스수량', key: 'quantity' },
        { header: '배송메세지1', key: 'memo' },
        { header: '배송메세지2', key: '_empty1' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-5850-4634',
      senderAddress: '제주도 제주시 구좌읍 비자림로 2615',
    },
  },
  {
    key: 'yeongseong',
    name: '영성수산',
    code: 'YS',
    courier: '한진택배',
    consolidate: true,
    filenameDateOffset: 0,
    settlement: true,
    template: {
      columns: [
        { header: '받는분', key: 'recipientName' },
        { header: '받는분 전화번호', key: 'recipientPhone' },
        { header: '', key: '_empty1' },
        { header: '', key: '_empty2' },
        { header: '', key: '_empty3' },
        { header: '받는분 주소', key: 'address' },
        { header: '보내시는분', key: 'senderName' },
        { header: '보내시는분 전화번호', key: 'senderPhone' },
        { header: '', key: '_empty4' },
        { header: '', key: '_empty5' },
        { header: '', key: '_empty6' },
        { header: '보내시는분 주소', key: 'senderAddress' },
        { header: '수량', key: 'quantity' },
        { header: '상품명', key: 'productName' },
        { header: '타입', key: '_type', defaultValue: 'a' },
        { header: '요금', key: '_fee', defaultValue: '선불' },
        { header: '', key: '_empty7' },
        { header: '배송메시지', key: 'memo' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-5850-4634',
      senderAddress: '제주시 대정읍 하모리',
    },
  },
  {
    key: 'sanghamango',
    name: '상하의망고농장',
    code: 'SH',
    courier: '한진택배',
    consolidate: true,
    filenameDateOffset: 0,
    settlement: true,
    template: {
      columns: [
        { header: '받으시는 분', key: 'recipientName' },
        { header: '받으시는분 번호', key: 'recipientPhone' },
        { header: '', key: '_empty1' },
        { header: '', key: '_empty2' },
        { header: '', key: '_empty3' },
        { header: '받으시는분 주소', key: 'address' },
        { header: '보내시는 분', key: 'senderName' },
        { header: '보내시는분 번호', key: 'senderPhone' },
        { header: '', key: '_empty4' },
        { header: '', key: '_empty5' },
        { header: '', key: '_empty6' },
        { header: '보내시는분 주소', key: 'senderAddress' },
        { header: '수량', key: 'quantity' },
        { header: '품명', key: 'productName' },
        { header: 'b', key: '_type', defaultValue: 'b' },
        { header: '선불', key: '_fee', defaultValue: '선불' },
        { header: '배송메시지', key: 'memo' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-5850-4634',
      senderAddress: '제주 서귀포시 대정읍 상하의망고농장',
    },
  },
  {
    key: 'biju',
    name: '비주비주농장',
    code: 'BJ',
    courier: 'CJ대한통운',
    consolidate: true,
    filenameDateOffset: 1,
    settlement: true,
    template: {
      columns: [
        { header: '', key: '_index' },
        { header: '송장번호', key: '_tracking' },
        { header: '받는분성명', key: 'recipientName' },
        { header: '받는분전화번호', key: 'recipientPhone' },
        { header: '받는분기타연락처', key: 'recipientPhone2' },
        { header: '', key: 'address' },
        { header: '보내는분성명', key: 'senderName' },
        { header: '보내는분전화번호', key: 'senderPhone' },
        { header: '보내는분기타연락처', key: '_empty1' },
        { header: '보내는분주소(전체, 분할)', key: 'senderAddress' },
        { header: '운임구분', key: '_empty2' },
        { header: '박스타입', key: '_empty3' },
        { header: '박스수량', key: 'quantity' },
        { header: '품목명', key: 'productName' },
        { header: '배송메세지1', key: 'memo' },
        { header: '주문일시', key: '_empty4' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-5850-4634',
      senderAddress: '제주시 한림읍',
    },
  },
  {
    key: 'oreum',
    name: '오름젓갈',
    code: 'ORM',
    courier: 'CJ대한통운',
    consolidate: true,
    filenameDateOffset: 1,
    template: {
      columns: [
        { header: '받는분성명', key: 'recipientName' },
        { header: '받는분주소(전체, 분할)', key: 'address' },
        { header: '받는분전화번호', key: 'recipientPhone' },
        { header: '받는분기타연락처', key: 'recipientPhone2' },
        { header: '보내는분성명', key: 'senderName' },
        { header: '보내는분주소(전체, 분할)', key: 'senderAddress' },
        { header: '보내는분전화번호', key: 'senderPhone' },
        { header: '보내는분기타연락처', key: '_empty1' },
        { header: '박스수량', key: 'quantity' },
        { header: '품목명', key: 'productName' },
        { header: '배송메세지1', key: 'memo' },
        { header: '기본운임', key: '_empty2' },
        { header: '운임구분', key: '_fee', defaultValue: '선불' },
      ],
      senderName: '제주로부터',
      senderPhone: '010-5850-4634',
      senderAddress: '제주특별자치도 제주시 한림읍 중산간서로 4463',
    },
  },
  {
    key: 'samsangol',
    name: '삼산골농장',
    code: 'N9G',
    courier: 'CJ대한통운',
    consolidate: true,
    filenameDateOffset: 1,
    template: {
      columns: [
        { header: '받는분성명', key: 'recipientName' },
        { header: '받는분주소(전체, 분할)', key: 'address' },
        { header: '받는분전화번호', key: 'recipientPhone' },
        { header: '받는분기타연락처', key: 'recipientPhone2' },
        { header: '보내는분성명', key: 'senderName' },
        { header: '보내는분주소(전체, 분할)', key: 'senderAddress' },
        { header: '보내는분전화번호', key: 'senderPhone' },
        { header: '보내는분기타연락처', key: '_empty1' },
        { header: '박스수량', key: 'quantity' },
        { header: '품목명', key: 'productName' },
        { header: '배송메세지1', key: 'memo' },
        { header: '기본운임', key: '_empty2' },
        { header: '운임구분', key: '_fee', defaultValue: '선불' },
      ],
      senderName: '남해로부터',
      senderPhone: '010-5850-4634',
      senderAddress: '',
    },
  },
];
